module.exports = __webpack_public_path__ + "assets/static/png/mp_logo_full.5b17d2c7d71ef4fdaa5dd8da5e349017.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/masterpassAuthForm/images/mp_logo_full.png
 ** module id = 477
 ** module chunks = 1
 **/